import styled from "styled-components";

export const Container = styled.div`
  .footer-container {
    background: rgba(195, 93, 30, 1);
    color: #fff;
    width: auto;
    height: 145px;
    padding: 10px;
    .footer-container__contact {
      text-align: left;
      max-width: 1440px;
      width: 1024px;
      margin: -15px auto;
      .footer-container__contact__copy {
        margin-top: 0px;
        font-family: Open Sans;
        .footer-container__contact__copy__ol__item {
          img {
            width: 32px;
            height: 32px;
            vertical-align: middle;
          }
        }
      }
      .footer-container__contact__title {
        font-size: 40px;
        font-family: Raleway;
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
    }
  }

  @media (max-width: 1024px) {
    .footer-container__contact {
      width: auto !important;
    }
  }
`;
